<div class="work-flow-container">
    <div>
        <div class="flex justify-center">
            <img class="work-flow-icon" src="/assets/images/received-needs-icon.svg" />
        </div>
        <div class="title">Received Needs</div>
        <div class="content">Once we’ve received and processed your request, we’ll get back to you to detail your project needs.</div>
    </div>
    <div class="right-arrow">
        <img src="/assets/images/step-1-arrow.svg" />
    </div>
    <div class="down-arrow justify-center">
        <img class="block md:hidden" src="/assets/images/down-arrow-small.svg" />
        <img class="hidden md:block" src="/assets/images/down-arrow.svg" />
    </div>
    <div>
        <div class="flex justify-center"><img class="work-flow-icon" src="/assets/images/cost-estimates.svg" /></div>
        <div class="title">Cost Estimates</div>
        <div class="content">
            <div class="sub-title">Scope of Work:</div>
            <div>Detailed deliverables & milestones.</div>
            <div class="sub-title">Resource Plan:</div>
            <div>Team composition (e.g., developers, designers) and timeline.</div>
            <div class="sub-title">Cost Transparency:</div>
            <div>Fixed-fee or agile billing models, with no hidden costs.</div>
        </div>
    </div>
    <div class="right-arrow">
        <img src="/assets/images/step-2-arrow.svg" />
    </div>
    <div class="down-arrow justify-center">
        <img class="block md:hidden" src="/assets/images/down-arrow-small.svg" />
        <img class="hidden md:block" src="/assets/images/down-arrow.svg" />
    </div>
    <div>
        <div class="flex justify-center"><img class="work-flow-icon" src="/assets/images/meeting-icon.svg" /></div>
        <div class="title">Meeting</div>
        <div class="content">Refined project goals and success metrics. Risk management and change-request protocols. Final approval steps for seamless execution.</div>
    </div>
    <div class="right-arrow">
        <img src="/assets/images/step-3-arrow.svg" />
    </div>
    <div class="down-arrow justify-center">
        <img class="block md:hidden" src="/assets/images/down-arrow-small.svg" />
        <img class="hidden md:block" src="/assets/images/down-arrow.svg" />
    </div>
    <div>
        <div class="flex justify-center"><img class="work-flow-icon" src="/assets/images/start-working-icon.svg" /></div>
        <div class="title">Start Working</div>
        <div class="content">Kickoff meeting to align roles and timelines. Dedicated project manager for real-time updates. Access to our client portal for progress tracking.</div>
    </div>
</div>
